import { FormattedMessage } from 'react-intl';
import { Button } from '@mui/material';
import { DATE_FORMAT, truncateText } from '@ui-framework/index';
import dayjs from 'dayjs';

function buttonActions(original, props, accessorFunctionsAdditional) {
  if (!original?.isActive) {
    return null;
  }
  return (
    <Button
      size="small"
      variant="outlined"
      color="error"
      onClick={() => {
        accessorFunctionsAdditional.openRevokeModal(original);
      }}>
      <FormattedMessage id="REVOKE_ACCESS" defaultMessage="Revoke Access" />
    </Button>
  );
}

function APIKey(original) {
  const keyValue = original?.key || '';
  return keyValue.padStart(keyValue.length + 10, '*');
}

function UserRole(original) {
  return original?.role?.roleIdentifier || '';
}

function description(original) {
  return truncateText(original?.description) || '';
}

function createdDateTime(original) {
  return original?.createdDateTime
    ? dayjs(original?.createdDateTime).format(DATE_FORMAT.MEDIUM_DATE)
    : '';
}

function expiresAt(original) {
  return original?.expiresAt
    ? dayjs(original?.expiresAt).format(DATE_FORMAT.MEDIUM_DATE)
    : '';
}

function lastModifiedBy(original) {
  return original?.lastModifiedBy || '';
}

function lastModifiedDateTime(original) {
  return original?.lastModifiedDateTime
    ? dayjs(original?.lastModifiedDateTime).format(DATE_FORMAT.MEDIUM_DATE)
    : '';
}

function isActive(original) {
  if (original?.isActive) {
    return 'Active';
  }
  if (original?.expired) {
    return 'Expired';
  }
  return 'Revoked';
}

export {
  APIKey,
  UserRole,
  isActive,
  createdDateTime,
  expiresAt,
  description,
  lastModifiedDateTime,
  buttonActions,
  lastModifiedBy,
};
